export default Object.freeze({
  AcceptOrder: 'Accepted order',
  AddDriverModalOpened: 'add-driver-modal-opened',
  AddDriverModalClosed: 'add-driver-modal-closed',
  AddDriverModalDriverAdded: 'add-driver-modal-driver-added',
  AddNewStoreAchClicked: 'add-new-store-ach-clicked',
  AddNewStoreBackToAddNewStoreClicked: 'add-new-store-back-to-new-store-clicked',
  AddNewStoreFormstackClicked: 'add-new-store-formstack-clicked',
  AddNewStorePhotoShootLinkClicked: 'add-new-store-photo-shoot-link-clicked',
  AddNewStoreUploadPhotosLinkClicked: 'add-new-upload-photos-link-clicked',
  AnonymousContactOrderAcceptMessageLoginLink:
    'anonymous-contact-order-accept-message-login-link-clicked',
  AnonymousContactOrderAcceptMessageSignUpLink:
    'anonymous-contact-order-accept-message-sign-up-clicked',
  AnonymousContactOrderReconfirmMessageLoginLink:
    'anonymous-contact-order-reconfirm-message-login-link-clicked',
  AnonymousContactOrderReconfirmMessageSignUpLink:
    'anonymous-contact-order-reconfirm-message-sign-up-clicked',
  AssignDriverModalDismissed: 'assign-driver-modal-closed',
  AssignDriverModalViewed: 'Assign Driver Modal View',
  AssignDriverReminderModalViewed: 'Assign Driver Reminder Modal View',
  AutoEzDispatchRuleDeliveryDistanceEnableToggled:
    'auto-ezdispatch-rule-delivery-distance-enable-toggled',
  AutoEzDispatchRuleLeadTimeEnableToggled: 'auto-ezdispatch-rule-lead-time-enable-toggled',
  AutoEzDispatchRuleOrderSizeEnableToggled: 'auto-ezdispatch-rule-order-size-enable-toggled',
  AutoEzDispatchRuleTimeOfDayEnableToggled: 'auto-ezdispatch-rule-time-of-day-enable-toggled',
  AutoEzDispatchSaveClicked: 'auto-ezdispatch-save-clicked',
  AutomaticTempClosureBannerDisplayed: 'automatic-temp-closure-banner-displayed',
  AutomaticTempClosureBannerClosed: 'automatic-temp-closure-banner-closed',
  BluredMenuSearchInput: 'blured-menu-search-input',
  BluredSpecialInstructions: 'blured-special-instructions',
  BluredReviewOrderCCEmails: 'blured-review-order-cc-emails',
  BulkUpdatePppSubmit: 'bulk-update-ppp-submitted',
  BulkUpdateEzRewardsSubmit: 'bulk-update-ezrewards-submitted',
  CancelAddedDiscountOrFeeDirectEntry: 'cancel-added-discount-or-fee-direct-entry',
  CapacityToolingCreation: 'capacity-tooling-creation',
  ClickedAccountSettingsContactMethodsSaveButton:
    'clicked-account-settings-contact-methods-save-button',
  ClickedBulkEditHolidayClosuresEditButton: 'clicked-bulk-edit-holiday-closures-edit-button',
  ClickedBulkEditLeadTimesEditButton: 'clicked-bulk-edit-lead-times-edit-button',
  ClickedBulkLeadTimeSaveButton: 'clicked-bulk-lead-time-save-button',
  ClickedBulkEditOperatingHoursEditButton: 'clicked-bulk-edit-operating-hours-button',
  ClickedBulkEditTemporaryClosuresEditButton: 'clicked-bulk-edit-temporary-closures-edit-button',
  ClickedBulkTemporaryClosuresSaveButton: 'clicked-bulk-temporary-closures-save-button',
  ClickedBulkOperatingHoursSaveButton: 'clicked-bulk-operating-hours-save-button',
  ClickedBulkEditDailyCapacityEditButton: 'clicked-bulk-edit-daily-capacity-edit-button',
  ClickedCpDisputeDrawerButton: 'clicked-cp-dispute-drawer-button',
  ClickedDirectEntryAddCustomMenuItemButton: 'clicked-add-custom-menu-item-button',
  ClickedDirectEntryAddCustomMenuItemToOrder: 'clicked-add-to-order-button-clicked',
  ClickedDirectEntryProceedPaymentButton: 'Clicked DirectEntryProceedPayment Button',
  ClickedDirectEntrySaveAndExitButton: 'Clicked DirectEntrySaveAndExit Button',
  ClickedDirectEntrySaveDraftButton: 'Clicked DirectEntrySaveDraft Button',
  ClickedDirectEntrySaveQuoteButton: 'Clicked DirectEntrySaveQuote Button',
  ClickedDisputeFulfillmentIssue: 'clicked-dispute-fulfillment-issue',
  ClickedDownloadContactsList: 'clicked-download-contacts-list',
  ClickedDuplicateOrderButton: 'Clicked Duplicate Order Button',
  ClickedDuplicatePastOrderButton: 'Clicked Duplicate Past Order Button',
  ClickedEditVisibleAccount: 'Clicked edit visible account',
  ClickedEzDispatchWheneverBannerLearnMoreLink:
    'clicked-ezdispatch-whenever-banner-learn-more-link',
  ClickedEzDispatchWheneverBannerDissmissButton:
    'clicked-ezdispatch-whenever-banner-dissmiss-button',
  ClickedLeadTimeSaveButton: 'clicked-lead-time-save-button',
  ClickedMenuItemTile: 'clicked-menu-item-tile',
  ClickedOperatingHoursSaveButton: 'clicked-operating-hours-save-button',
  ClickedOrderDetailsTableLink: 'clicked-order-details-table-link',
  ClickedOrderDrilldownOrderLink: 'clicked-order-drilldown-order-link',
  ClickedOrderItemCloseButton: 'clicked-order-item-close-button',
  ClickedOrderEntryCancelButtonToOpenModal: 'clicked-order-entry-cancel-button-to-open-modal',
  ClickedOrderEntryCancelButtonToCancelOrder: 'clicked-order-entry-cancel-button-to-cancel-order',
  ClickedOrderEntryCancelButtonToCloseModal: 'clicked-order-entry-cancel-button-to-close-modal',
  ClickedOrderSourcesFilter: 'clicked-order-sources-filter',
  ClickedPayoneerApplicationLink: 'clicked-payoneer-application-link',
  ClickedPayoneerTaxLink: 'clicked-payoneer-tax-link',
  ClickedReviewQuotesApproveQuoteButton: 'Clicked ReviewQuotes ApproveQuoteButton',
  ClickedReviewQuotesDeleteQuoteButton: 'Clicked ReviewQuotes DeleteQuoteButton',
  ClickedReviewQuotesEditQuoteButton: 'Clicked ReviewQuotes EditQuoteButton',
  ClickedSettingsAddStoreUser: 'clicked-settings-add-store-user',
  ClickedSettingsAddTemporaryClosure: 'clicked-settings-add-temporary-closure',
  ClickedSettingsEditLeadTimes: 'clicked-settings-edit-lead-times',
  ClickedSettingsEditStoreDetails: 'clicked-settings-edit-store-details',
  ClickedSettingsEditTemporaryClosures: 'clicked-settings-edit-temporary-closures',
  ClickedSettingsEditOperatingSchedules: 'clicked-settings-edit-operating-schedules',
  ClickedSettingsEditDailyCapacity: 'clicked-settings-edit-daily-capacity',
  ClickedSettingsRemoveTemporaryClosure: 'clicked-settings-remove-temporary-closure',
  ClickedSettingsRequestUpdateBanner: 'clicked-settings-request-update-banner',
  ClickedSettingsRequestUpdateContact: 'clicked-settings-request-update-contact',
  ClickedSettingsRequestUpdateDelivery: 'clicked-settings-request-update-delivery',
  ClickedSettingsRequestUpdateDetails: 'clicked-settings-request-update-details',
  ClickedSettingsRequestUpdateHours: 'clicked-settings-request-update-hours',
  ClickedSettingsRequestUpdateLeadTimeAndCutoff:
    'clicked-settings-request-update-lead-time-and-cutoff',
  ClickedSettingsRequestUpdateStoreContacts: 'clicked-settings-request-update-store-contacts',
  ClickedSettingsRequestUpdateTemporaryClosures:
    'clicked-settings-request-update-temporary-closures',
  ClickedSponsoredListingNewCampaignButton: 'clicked-sponsored-listing-new-campaign-button',
  ClickedSponsoredListingFAQ: 'clicked-sponsored-listing-faq',
  ClickedSponsoredListingCampaignEditBiddingConfirm:
    'clicked-sponsored-listing-campaign-edit-bidding-confirm',
  ClickedSponsoredListingCampaignEditBiddingDismiss:
    'clicked-sponsored-listing-campaign-edit-bidding-dismiss',
  ClickedSponsoredListingPauseCampaign: 'clicked-sponsored-listing-pause-campaign',
  ClickedSponsoredListingPauseCampaignConfirm: 'clicked-sponsored-listing-pause-campaign-confirm',
  ClickedSponsoredListingPauseCampaignDismiss: 'clicked-sponsored-listing-pause-campaign-dismiss',
  ClickedSponsoredListingPauseCampaignLocation: 'clicked-sponsored-listing-pause-campaign-location',
  ClickedSponsoredListingResumeCampaign: 'clicked-sponsored-listing-resume-campaign',
  ClickedSponsoredListingResumeCampaignConfirm: 'clicked-sponsored-listing-resume-campaign-confirm',
  ClickedSponsoredListingResumeCampaignDismiss: 'clicked-sponsored-listing-resume-campaign-dismiss',
  ClickedSponsoredListingResumeCampaignLocation:
    'clicked-sponsored-listing-resume-campaign-location',
  ClickedSponsoredListingDeleteCampaign: 'clicked-sponsored-listing-delete-campaign',
  ClickedSponsoredListingDeleteCampaignConfirm: 'clicked-sponsored-listing-delete-campaign-confirm',
  ClickedSponsoredListingDeleteCampaignDismiss: 'clicked-sponsored-listing-delete-campaign-dismiss',
  ClickedSponsoredListingEditCampaign: 'clicked-sponsored-listing-edit-campaign',
  ClickedSponsoredListingFormNavigationButton: 'clicked-sponsored-listing-form-navigation-button',
  ClickedSponsoredListingFormSubmitButton: 'clicked-sponsored-listing-form-submit-button',
  ClickedSponsoredListingFormField: 'clicked-sponsored-listing-form-field',
  ClickedSponsoredListingLink: 'clicked-sponsored-listing-link',
  ClickedSponsoredPromoFormNavigationButton: 'clicked-sponsored-promo-form-navigation-button',
  ClickedSponsoredPromoFormField: 'clicked-sponsored-promo-form-field',
  ClickedSponsoredPromoFormSubmitButton: 'clicked-sponsored-promo-form-submit-button',
  ClickedReviewOrderSubmitButton: 'clicked-review-order-submit-button',
  ClickedReviewOrderEditOrderButton: 'clicked-review-order-edit-order-button',
  ClickedRequestEzDispatchModalButton: 'clicked-request-ezdispatch-modal-button',
  ClickedSettingsSaveTemporaryClosures: 'clicked-settings-save-temporary-closures',
  ClickedTaxExemptCheckboxDirectEntry: 'clicked-tax-exempt-checkbox-direct-entry',
  ClickedTimeDropdownFilterOption: 'clicked-time-dropdown-filter-option',
  ClosedCpDisputeDrawer: 'closed-cp-dispute-drawer',
  CompletedBulkChangeSummary: 'completed-bulk-change-summary',
  ContactDeactivated: 'contact-deactivated',
  ContactInvitationRevoked: 'contact-invitation-revoked',
  CreateOrderCapacityTemporaryClosure: 'create-order-capacity-temporary-closure',
  DailyCapacityFormErrors: 'daily-capacity-form-errors',
  DeleteExistingDiscountOrFeeDirectEntry: 'delete-existing-discount-or-fee-direct-entry',
  DeliveryManagementClickedReportingSelectDateRange: 'clicked-reporting-select-date-range',
  DeliveryManagementClickedExpandAssignedDeliveryCard: 'clicked-expand-assigned-delivery-card',
  DeliveryManagementClickedExpandCompletedDeliveryCard: 'clicked-expand-completed-delivery-card',
  DeliveryManagementClickedOpenDropoffDetailsModal: 'clicked-open-dropoff-details-modal',
  DeliveryManagementClickedExpandAssignedDeliveriesButton:
    'clicked-expand-assigned-deliveries-button',
  DeliveryManagementClickedExportReportingDataButton: 'clicked-export-reporting-data-button',
  DeliveryManagementClickedSubmitDriverCreate: 'clicked-submit-driver-create-button',
  DeliveryManagementClickedSubmitDriverDelete: 'clicked-submit-driver-delete-button',
  DeliveryManagementClickedSubmitDriverEdit: 'clicked-submit-driver-edit-button',
  DeliveryPerformanceReportingClickedStoreSelect: 'delivery-performance-clicked-store-select',
  DeliveryPerformanceReportingClickedTimeRangeSelect:
    'delivery-performance-clicked-time-range-select',
  DeliveryPerformanceReportingClickedEzDispatchCheckbox:
    'delivery-performance-clicked-ezdispatch-checkbox',
  DeliveryPerformanceReportingClickedTableOrderLink:
    'delivery-performance-clicked-table-order-link',
  DeliveryPerformanceReportingSummaryClickedHelpCenterLink:
    'delivery-performance-summary-clicked-help-center-link',
  DeliveryTrackingLinkClicked: 'delivery-tracking-link-clicked',
  DeliverySetupTooltipOpened: 'delivery-setup-tooltip-opened',
  DemographicDataCancelClicked: 'demographic-cancel-clicked',
  DemographicDataClearFilters: 'clear-demographic-filters',
  DemographicDataClickSave: 'save-demographic-data-clicked',
  DemographicDataDataCickFaqLink: 'demographic-faq',
  DemographicDataEditSelectedStores: 'demographic-data-edit-selected-stores',
  DemographicDataFromAccountSettings: 'edit-demographic-info-from-account',
  DemographicDataFromStoreSettings: 'edit-demographic-info-from-from-store-settings',
  DemographicDataSortStores: 'demographic-sort-stores',
  DemographicDataStoreSelectionChange: 'demographic-store-selection-change',
  DemographicDataSuccessfulUpdate: 'demographic-data-saved',
  DismissOrderCapacityModal: 'dismiss-order-capacity-modal',
  DismissTermsAndConditionsModal: 'dismiss-terms-and-conditions-modal',
  DownloadedOrderPDF: 'downloaded-order-pdf',
  EditedDeliveryFeeDirectEntry: 'edited-delivery-fee-direct-entry',
  EditStoreDetailsSaveChangesClicked: 'clicked-edit-store-details-save-changes',
  EndCatererMarkOrderReadyForPickupFlow: 'end-caterer-mark-order-ready-for-pickup-flow',
  EzDispatchWheneverButtonAvailable: 'ezdispatch-whenever-button-available',
  EzDispatchWheneverClickedDuringRejection: 'ezdispatch-whenever-clicked-during-rejection',
  EzDispatchWheneverModalOpened: 'ezdispatch-whenever-modal-opened',
  EzManagePermissionChanged: 'Changed ezManage Permission status',
  EzOrderingAcceptMessageClicked: 'Clicked EzOrderingAcceptMessage Component',
  EzOrderingAcceptMessageDismissed: 'Dismissed EzOrderingAcceptMessage Component',
  EzOrderingMarketingPageNoWebsite: "Clicked don't have a website link",
  EzOrderingMarketingPageSetupYourLinkNow: 'Clicked setup your link',
  EzOrderingMarketingPageSignUpTodayHeader: 'Clicked Sign Up Today (header)',
  EzOrderingMarketingPageSignUpTodayFooter: 'Clicked Sign Up Today (footer)',
  EzOrderingPopupClicked: 'Clicked ezOrdering ribbon link',
  FeeOrDiscountAddedDirectEntry: 'fee-or-discount-added-direct-entry',
  FailedDirectEntrySubmit: 'failed-direct-entry-submit',
  FilteredOrdersTableViewed: 'filtered-orders-table-viewed',
  FoodReadyPhotoViewed: 'food-ready-photo-viewed',
  GenerateMarketplacePromosReport: 'generate-marketplace-promos-report',
  GenerateReliabilityMetricsReport: 'generate-reliability-metrics-report',
  GenerateSponsoredListingsReport: 'generate-sponsored-listings-report',
  GuidedOnboardingBookPhotoSessionClicked: 'book-photo-session-clicked',
  GuidedOnboardingContactFormAddContact: 'add-contact',
  GuidedOnboardingContactFormDeleteContact: 'delete-contact',
  GuidedOnboardingFAQOpened: 'open-faq',
  GuidedOnboardingSelectMenuFiles: 'select-menu-files',
  GuidedOnboardingMenuRequirementsClicked: 'menu-requirements-clicked',
  GuidedOnboardingUploadMenuItemPhotos: 'upload-menu-item-photos',
  GuidedOnboardingAddDeliveryFeeTier: 'add-delivery-tier',
  GuidedOnboardingDeleteDeliveryFeeTier: 'delete-delivery-tier',
  GuidedOnboardingFinalFormSubmission: 'final-form-submission',
  GuidedOnboardingFormPageOpened: 'form-page-opened',
  GuidedOnboardingMenuAddAnotherUrlClicked: 'add-menu-url',
  GuidedOnboardingPageFormSubmission: 'page-form-submission',
  InvitedNewCateringPartnerAccount: 'invited-new-catering-partner-account',
  InvitedExistingCateringPartnerAccount: 'invited-existing-catering-partner-account',
  MenuFormSubmissionFailure: 'menu-form-submission-failure',
  ModificationModalViewed: 'modification-modal-viewed',
  ModificationModalButtonClicked: 'modification-modal-button-clicked',
  NewAddressCreated: 'new-address-created',
  NotificationPreferenceForAStoreChanged: 'notification-preference-for-a-store-changed',
  NotificationPreferenceForAllStoresChanged: 'notification-preference-for-all-stores-changed',
  OnboardingEZOrderingLinkClicked: 'onboarding-ez-ordering-link-clicked',
  OnboardingIntegrationsLinkClicked: 'onboarding-integrations-link-clicked',
  OnboardingMarketplaceLinkClicked: 'onboarding-marketplace-link-clicked',
  OnboardingPageLoaded: 'onboarding-page-loaded',
  OnboardingPhotoUpdateFormLinkClicked: 'onboarding-photo-update-form-link-clicked',
  OnboardingRelishLinkClicked: 'onboarding-relish-link-clicked',
  OnboardingSmartshootLinkClicked: 'onboarding-smartshoot-link-clicked',
  OpenLiveChat: 'opened-chat',
  OpenPrintModal: 'ca-open-print-modal',
  OpenOrderAttributionDrawer: 'open-order-attribution-drawer',
  OperationalMetricsOrdersComboBanner: 'operational-metrics-orders-combo-banner',
  OperationalMetricsOrdersPauseBanner: 'operational-metrics-orders-pause-banner',
  OperationalMetricsOrdersWarnBanner: 'operational-metrics-orders-warn-banner',
  OperationalMetricsCatererSelected: 'operational-metrics-caterer-selected',
  OperationalMetricsDeliveryTrackingCardClicked:
    'operational-metrics-delivery-tracking-card-clicked',
  OperationalMetricsDrawerOpened: 'operational-metrics-drawer-opened',
  OperationalMetricsDrawerCardLink: 'operational-metrics-drawer-card-link',
  OperationalMetricsHelpCenter: 'operational-metrics-help-center',
  OperationalMetricsModalOpened: 'operational-metrics-modal-opened',
  OperationalMetricsEducationalLinks: 'operational-metrics-educational-links',
  OperationalMetricsModalButtonClicked: 'operational-metrics-modal-button-clicked',
  OperationalMetricsWarningBanner: 'operational-metrics-warning-banner',
  OperationalMetricsWarningBannerViewed: 'operational-metrics-warning-banner-viewed',
  OperationalMetricsAlertBanner: 'operational-metrics-alert-banner',
  OperationalMetricsCloseBanner: 'operational-metrics-close-banner',
  OperationalMetricsIndexPageViewed: 'operational-metrics-index-page-viewed',
  OperationalMetricsPausedBannerViewed: 'operational-metrics-paused-banner-viewed',
  OperationalMetricsUnpausedBannerViewed: 'operational-metrics-unpaused-banner-viewed',
  OpsSettingsBannerClose: 'operational-settings-close-banner',
  OrdersCloseBanner: 'orders-close-banner',
  OrderSearchEntered: 'order-search-entered',
  PrintedOrder: 'printed-order',
  PoliciesExitButtonClicked: 'policies-exit-button-clicked',
  PoliciesPageViewed: 'policies-page-viewed',
  PoliciesSaveChangesButtonClicked: 'policies-save-changes-button-clicked',
  PoliciesStayOnPageButtonClicked: 'policies-stay-on-page-button-clicked',
  ProductMixTableBrandIdChanged: 'product-mix-table-brand-id-changed',
  ProductMixTableReportingPeriodChanged: 'product-mix-table-reporting-period-changed',
  ProductMixTableSortChanged: 'product-mix-table-sort-changed',
  PromotionsClickBackFromForm: 'go_back_ezo_promo',
  PromotionsClickCancelSubmitPromotion: 'cancel_submit_ezo_promo',
  PromotionsClickConfirmSubmitPromotion: 'confirm_submit_ezo_promo',
  PromotionsClickCreatePromotion: 'create_ezo_promo',
  PromotionsClickSubmitPromotion: 'submit_ezo_promo',
  PromotionDetailsClickedBack: 'back to promotions page',
  PromotionDetailsClickedEndPromotion: 'end promotion button',
  PromotionDetailsCopyLinkOverviewPanel: 'copy_promo_link_overview_panel',
  PromotionDetailsCopyLinkRedemptionPanel: 'copy_promo_link_redemptions_panel',
  QuoteSentToCustomerCCPayment: 'quote-sent-to-customer-with-cc-payment',
  QuoteSentToCustomerExternalPayment: 'quote-sent-to-customer-with-external-payment',
  QuoteSentToCustomerPreCustomerQuotes: 'quote-sent-to-customer-pre-customer-quote',
  ReactivatedCateringPartnerAccount: 'reactivated-catering-partner-account',
  RejectModalCategorySelected: 'reject-modal-category-selected',
  RejectModalDismissed: 'reject-modal-dismissed',
  RejectModalOpened: 'reject-modal-opened',
  RejectModalReasonSelected: 'reject-modal-reason-selected',
  RejectModalSubmitted: 'reject-modal-submitted',
  ReliabilityRockstarAllDeliveriesLinkClicked: 'reliability-rockstar-all-deliveries-link-clicked',
  ReliabilityRockstarAllOrdersLinkClicked: 'reliability-rockstar-all-orders-link-clicked',
  ReliabilityRockstarCancellationsLinkClicked: 'reliability-rockstar-cancellations-link-clicked',
  ReliabilityRockstarCatererSelected: 'reliability-rockstar-caterer-selected',
  ReliabilityRockstarContactLinkClicked: 'reliability-rockstar-contact-link-clicked',
  ReliabilityRockstarProgramInfoLinkClicked: 'reliability-rockstar-program-info-link-clicked',
  ReliabilityRockstarRejectionsLinkClicked: 'reliability-rockstar-rejections-link-clicked',
  ReliabilityRockstarOrderAccuracyLinkClicked: 'reliability-rockstar-order-accuracy-link-clicked',
  ReliabilityRockstarDeliveryTrackingLinkClicked:
    'reliability-rockstar-delivery-tracking-link-clicked',
  RequestModificationButton: 'order-support-button-clicked',
  RequestModificationModalButton: 'order-support-modal-button-clicked',
  ResendCateringPartnerAccountInvite: 'resend-catering-partner-account-invite',
  ReturnToNewPerformanceMetrics: 'return-to-new-performance-metrics-link-clicked',
  RevertToOldPerformance: 'revert-to-old-performance-link-clicked',
  SelectedCreditCard: 'selected-credit-card',
  SelectedExternalPayment: 'selected-external-payment',
  SelectedHouseAccount: 'selected-house-account',
  SelectedInStorePayment: 'selected-in-store-payment',
  SmsComplianceModalSubmitted: 'sms-compliance-modal-submitted',
  StartCatererMarkOrderReadyForPickupFlow: 'start-caterer-mark-order-ready-for-pickup-flow',
  SubmitCaterererSubmittedOrderRefund: 'submit-catererer-submitted-order-refund',
  StoreSelectorModalOpened: 'store-selector-modal-opened',
  SendQuoteModalCreditCardSelected: 'send-quote-modal-credit-card-payment-selected',
  SendQuoteModalInStoreSelected: 'send-quote-modal-in-store-payment-selected',
  ServicesAndFeesSettingsTabRequestEzOrdering: 'Clicked Request ezOrdering',
  StoreAccessAddedToCateringPartnerAccount: 'store-access-added-to-catering-partner-account',
  StoreSelectorCatererChanged: 'store-selector-caterer-changed',
  StoreSelectorModalDismissed: 'store-selector-modal-dismissed',
  StoreSelectorModalSubmitted: 'store-selector-modal-submitted',
  StoreAccessRemovedFromCateringPartnerAccount:
    'store-access-removed-from-catering-partner-account',
  TipUpdatedByCaterer: 'tip-updated-by-caterer',
  UpdateEzRewardsSubmit: 'update-ezRewards-submit',
  UpdatePppSubmit: 'update-ppp-submit',
  UpdateExistingDiscountOrFeeDirectEntry: 'update-existing-discount-of-fee-direct-entry',
  clickedCovidTemporaryClosuresOrderIndex: 'clicked-covid-temporary-closures-order-index',
  clickCovidOperatingHoursOrderIndex: 'clicked-covid-operating-hours-order-index',
  clickedCovidTemporaryClosuresRejectModal: 'clicked-covid-temporary-closures-reject-modal',
  clickCovidOperatingHoursRejectModal: 'clicked-covid-operating-hours-reject-modal',
  PrintOrderFromCA: 'printed-order-caterer-accept',
  PrintOrderFromModificationConfirm: 'print-order-from-modification-confirm',
  DownloadOrderFromCA: 'download-order-caterer-accept',
  SubwayOrderSearchSubmitted: 'subway-order-search-submitted',
  SubwayOrderSearchResultClicked: 'subway-order-search-result-clicked',
  SubwayStoreSearchSubmitted: 'subway-store-search-submitted',
  SubwayStoreSearchResultClicked: 'subway-store-search-result-clicked',
  SponsoredListingCampaignsReportsCampaignSelect:
    'sponsored-listing-campaigns-reports-campaign-select',
  SponsoredListingCampaignsReportsTimeFrameChange:
    'sponsored-listing-campaigns-reports-time-frame-change',
  SponsoredPromoReportsTimeFrameChange: 'sponsored-promo-reports-time-frame-change',
  SponsoredPromoDetailsTimeFrameChange: 'sponsored-promo-details-time-frame-change',
  SponsoredPromoReportsPromoSelect: 'sponsored-promo-reports-promo-select',
  SponsoredPromoDetailsLocationSelect: 'sponsored-promo-details-location-select',
  SponsoredPromoTableSearch: 'sponsored-promo-table-search',
  SponsoredPromoEndClicked: 'clicked-sponsored-promo-end',
  SponsoredPromoEndConfirmClicked: 'clicked-sponsored-promo-end-confirm',
  SponsoredPromoEndDismissClicked: 'clicked-sponsored-promo-end-dismiss',
  SponsoredPromoDetailsTableSearch: 'sponsored-promo-details-table-search',
} as const);
